import React from 'react';
import { CalendarClock } from 'lucide-react';
import { DataTable, ColumnDef } from '../../../../../components/shared/DataTable/DataTable';
import { FISCAL_DEADLINES, FiscalDeadline } from './financeMasters';
import '../../shared-modules.css';
import './FinanceMasters.css';

const STATUS_BADGE: Record<FiscalDeadline['status'], string> = {
  'Próximo plazo': 'inactive',
  'Borrador listo': 'active',
  Anual: 'draft'
};

const formatDate = (iso: string) => {
  const [y, m, d] = iso.split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
};

export const FinanceFiscalDeadlinesView = () => {
  const columns: ColumnDef<FiscalDeadline>[] = [
    {
      id: 'date',
      header: 'FECHA LÍMITE',
      render: (v) => <span className="fin-master__code">{formatDate(v.date)}</span>
    },
    {
      id: 'model',
      header: 'MODELO',
      render: (v) => (
        <>
          <div className="fin-master__name">{v.model}</div>
          <div className="fin-master__desc">{v.description}</div>
        </>
      )
    },
    {
      id: 'status',
      header: 'ESTADO',
      align: 'center',
      render: (v) => <span className={`module-badge ${STATUS_BADGE[v.status]}`}>{v.status}</span>
    },
    {
      id: 'note',
      header: 'OBSERVACIÓN',
      render: (v) => <span className="fin-master__sub">{v.note}</span>
    }
  ];

  return (
    <div className="fin-master">
      <DataTable
        data={FISCAL_DEADLINES}
        columns={columns}
        title={<><CalendarClock size={14} className="module-panel-title-icon" /> Calendario_De_Vencimientos_Fiscales_AEAT</>}
        subtitle={`TOTAL: ${FISCAL_DEADLINES.length}`}
        getRowId={(v) => v.id}
        emptyText="No hay vencimientos fiscales."
      />
    </div>
  );
};

export default FinanceFiscalDeadlinesView;
